// extracted by mini-css-extract-plugin
export default {"nav-bar":"Layout_nav-bar__XxaMN","content":"Layout_content__-XVhO"};